import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'anms-big-input',
    templateUrl: './big-input.component.html',
    styleUrls: ['./big-input.component.scss'],
    imports: [MatCardModule, CommonModule]
})
export class BigInputComponent {
  readonly placeholder = input<string>(undefined);

  readonly value = input('');
  readonly disabled = input(false);

  hasFocus = false;
}
